export enum PointPitchAlignment {
    Map = "Map",
    Viewport = "Viewport"
}